
const state = {
  setup: {
    "gameType" :0, // 0 GAME START
    "gameView" : 1, // 1 GAME VIEW
    "gameLevel" : null,
    "gameRules" : false,
    "gameStep" : 1,
    "hangmanLong": null,
    "memoryTime": null,
    "playerName": "",
    "sound": true,
    "mute": false,
  },
  hangman:{
    "missionName" : 'Pieniądze od podszewki',
    "gameName" : ' Bankosłówka',
    "gameAbout" : '<p>Zalicz misję, odgadując <br />słówka w grze.</p>',
    "gameRules" : '<p>Odgaduj bankosłówka. Poziom łatwy to 5 słów. <br />Poziom trudny - 15.</p>' +
        '<p>Klikaj literki, których brakuje w wyrazie. Prawidłowo wskazane literki uzupełnią puste pola. Odgadując jedno słowo, trzy razy można wskazać złą literkę.</p>' +
        '<p>Uważaj, żeby zmieścić się w wyznaczonym czasie.</p>' +
        '<p>Korzystaj ze słowniczka Bankosłówek. Wtedy czas gry się zatrzyma, a Ty poznasz słowa użyte w grze i dalej będzie już z górki.</p>',
    "step": 0,
    "life": 3,
    "videId": 'IRCjXYYRo3s',
    activeData: [],
    dataGame:[
      {
        code:'BANK',
        letters:['A','B','D','E','I','J','M','N','S','P','S','Ó','K','Ż','Ą','Ę','Y'],
        img:'bank.png',
        audio:'BANK.mp3'
      },
      {
        code:'BANKIER',
        letters:['A','B','D','E','I','J','M','N','Ą','P','R','W','Z','K',],
        img:'bankier.png',
        audio:'BANKIER.mp3'
      },
      {
        code:'BANKOMAT',
        letters:['A','B','G','E','H','J','M','N','Ą','O','R','W','T','K','M'],
        img:'bankomat.png',
        audio:'BANKOMAT.mp3'
      },
      {
        code:'BUDŻET',
        letters:['A','B','G','E','H','J','U','N','D','O','R','Ż','T','K','M'],
        img:'budzet.png',
        audio:'BUDZET_2.mp3'
      },
      {
        code:'GOTÓWKA',
        letters:['A','B','D','E','G','T','O','N','Ó','P','R','W','Z','K','Ż'],
        img:'gotowka.png',
        audio:'GOTOWKA.mp3'
      },
      {
        code:'HOLOGRAM',
        letters:['A','B','G','E','H','J','M','N','Ą','O','R','W','L','K','M'],
        img:'hologram.png',
        audio:'HOLOGRAM.mp3'
      },
      {
        code:'INWESTYCJA',
        letters:['A','B','C','E','W','I','M','N','Y','O','R','S','T','J',],
        img:'inwestycja.png',
        audio:'INWESTYCJA.mp3'
      },
      {
        code:'KIESZONKOWE',
        letters:['A','B','K','E','W','I','M','N','Y','O','R','S','Z','J','N'],
        img:'kieszonkowe.png',
        audio:'KIESZONKOWE_2.mp3'
      },
      {
        code:'LIMIT',
        letters:['A','B','C','E','H','I','M','N','Y','O','R','L','T','J','M'],
        img:'limit.png',
        audio:'LIMIT_1.mp3'
      },
      {
        code:'MENNICA',
        letters:['A','B','C','E','H','I','Ó','N','Y','O','R','S','T','J','M'],
        img:'mennica.png',
        audio:'MENNICA.mp3'
      },
      {
        code:'OSZCZĘDNOŚCI',
        letters:['A','Ę','C','E','H','I','D','N','Ś','O','R','S','T','J','Z'],
        img:'oszczednosci.png',
        audio:'OSZCZEDNOSCI.mp3'
      },
      {
        code:'PIENIĄDZ',
        letters:['A','Ą','C','E','H','Z','M','N','I','O','R','D','T','J','M'],
        img:'pieniadz.png',
        audio:'PIENIADZ.mp3'
      },
      {
        code:'PREMIA',
        letters:['A','B','C','E','P','I','M','N','Y','O','R','S','T','J','M'],
        img:'premia.png',
        audio:'PREMIA.mp3'
      },
      {
        code:'TRANSAKCJA',
        letters:['A','B','C','E','H','I','K','N','Y','O','R','S','T','J','M'],
        img:'transakcja.png',
        audio:'TRANSAKCJA_2.mp3'
      },
      {
        code:'WALUTA',
        letters:['A','B','C','W','H','I','M','N','Y','L','R','S','T','U','M'],
        img:'waluta.png',
        audio:'WALUTA.mp3'
      },
      {
        code:'KONTO',
        letters:['A','B','D','E','G','T','O','N','Ó','P','R','W','Z','K','Ż'],
        img:'konto_bankowe.png',
        audio:'KONTO.mp3'
      },
      {
        code:'POŻYCZKA',
        letters:['A','C','D','E','G','T','O','K','Ó','P','R','W','Z','Y','Ż'],
        img:'pozyczka.png',
        audio:'POZYCZKA.mp3'
      },
      {
        code:'SALDO',
        letters:['A','S','D','E','G','T','O','K','Ó','P','R','L','Z','Y','Ż'],
        img:'saldo.png',
        audio:'SALDO.mp3'
      }
    ]
  },
  memory:{
    "missionName" :'Bezpieczeństwo',
    "gameName" : 'Piny bez spiny',
    "gameAbout" : '<p>Dobierz karty w pary tak szybko <br />jak to możliwe</p>',
    "gameRules" : '<p>Ta gra jest jak memory, tylko z tyłu każdej karty są cyfry. To numery PIN.</p>' +
        '<p>Na kartach są pochowane pary takich samych PIN-ów. Odszukaj pary PIN-ów w wyznaczonym czasie. Klikaj kolejno dwie karty, jedna po drugiej. Karty na chwilę się odwrócą. Zapamiętuj ich położenie.<p>' +
        '<p>Jeśli to para - SUPER. Pamiętaj, odkrywanie PIN-u jest możliwe tylko w grze. W prawdziwym świecie nigdy ich nie ujawniamy!<p>',
    "videId": 'VJAng4W3Gl4',
    "dataSetCard":[
      {
        name: '1',
        img: '1.png',
      },
      {
        name: '2',
        img: '2.png',
      },
      {
        name: '3',
        img: '3.png',
      },
      {
        name: '4',
        img: '4.png',
      },
      {
        name: '5',
        img: '5.png',
      },
      {
        name: '6',
        img: '6.png',
      },
    ],
  },
  shop:{
    "missionName" :'ZARZĄDZAM BUDŻETEM',
    "gameName" : 'wirtualny sklepik',
    "gameAbout" : '<p>Rodzice proszą Cię o kupienie kilku produktów na śniadanie.<br />  Mama wspomniała, że za pomoc należy się nagroda - podwójna reszta z zakupów!</p>',
    "gameRules" : '<p>To jest gra o oszczędzaniu. Możesz wybrać wersję łatwą lub trudną.</p>' +
        '<p>Twoje zadanie to zrobić zakupy, zmieścić się w budżecie i mieć jak najwyższą resztę.<p>' +
        '<p>Czytaj listę zakupów. Wkładaj produkty do koszyka.<p>' +
        '<p>Pilnuj, żeby nie wydać za dużo. Jeśli zrobisz zakupy oszczędnie, to wygrasz i zaliczysz misję.<p>',
    "step": 0,
    "videId": 'UAeEltZ61Do',

    "products":[
      {
        name: 'Mleko',
        img: 'mleko.png',
        price: 4,
        hprice: 3,
        sku:'MLK'
      },
      {
        name: 'Ser',
        img: 'ser.png',
        price: 5,
        hprice: 3,
        sku:'SR'
      },
      {
        name: 'Chleb',
        img: 'chleb.png',
        price: 2,
        hprice: 2,
        sku:'CH3'
      },
      {
        name: 'Cukierek',
        img: 'cukierek.png',
        price: 1,
        hprice: 1,
        sku:'CU1'
      },
      {
        name: 'Banany',
        img: 'banan.png',
        price: 4,
        hprice: 3,
        sku:'BA'
      },
      {
        name: 'Ser',
        img: 'ser.png',
        price: 3,
        hprice: 6,
        sku:'SR'
      },
      {
        name: 'Mleko',
        img: 'mleko.png',
        price: 5,
        hprice: 6,
        sku:'MLK'
      },
      {
        name: '5Jaj',
        img: 'jajka_5.png',
        price: 4,
        hprice: 3,
        sku:'JA5'
      },
      {
        name: '5Jaj',
        img: 'jajka_5.png',
        price: 3,
        hprice: 5,
        sku:'JA5'
      },
      {
        name: 'Pomidor',
        img: 'pomidor.png',
        price: 3,
        hprice: 3,
        sku:'PM2'
      },
      {
        name: 'Chleb',
        img: 'chleb.png',
        price: 3,
        hprice: 4,
        sku:'CH3'
      },
      {
        name: 'Rogalik',
        img: 'rogalik.png',
        price: 2,
        hprice: 2,
        sku:'RO3'
      },
      {
        name: 'Pomidor',
        img: 'pomidor.png',
        price: 4,
        hprice: 2,
        sku:'PM2'
      },
      {
        name: 'Mafin',
        img: 'mufinka.png',
        price: 3,
        hprice: 3,
        sku:'MF3'
      },

    ],
    "productList":[
      {
        name: 'Mleko',
        sku:'MLK'
      },
      {
        name: 'Ser',
        sku:'SR',
      },
      {
        name: 'Pomidor',
        sku:'PM2',
      },
      {
        name: '5 Jaj',
        sku:'JA5',
      },
      {
        name: 'Chleb',
        sku: 'CH3'
      },
      {
        name: 'Banany',
        sku: 'BA'
      },
      {
        name: 'Rogalik',
        sku: 'RO3'
      },
    ],
    "max":14,
    "hmax":19,
    "limit": null,
  },
};

const actions = {
  gotoNextView({ commit }, payload){
    commit('SET_ACTIVE_VIEW', payload)
  },
  startGame({ commit }, payload){
    commit('SET_GAME_DATA', payload)
  },
  muteGame({ commit }, payload){
    commit('SET_GAME_MUTE', payload)
  },
  playerName({commit} , payload){
    commit('SET_PLAYER_NAME', payload)
  },
  setDifficulty({ commit }, payload) {
    commit('SET_GAME_LVL', payload)
    commit('SET_ACTIVE_VIEW', 4);
    if (payload === 'easy'){
      commit('SET_HANGMAN_LONG', 5);
      commit('SET_HANGMAN_DATASET', 5);
      commit('SET_MEMORY_TIME', 60);
      commit('SET_SHOP_MAX', 17);
      commit('SET_SHOP_LIMIT', 5);
    }else if (payload === 'hard'){
      commit('SET_HANGMAN_DATASET', 15);
      commit('SET_HANGMAN_LONG', 15);
      commit('SET_MEMORY_TIME', 90);
      commit('SET_SHOP_MAX', 19);
      commit('SET_SHOP_LIMIT', 7);
    }
  },
  setGameRole({ commit }) {
    commit('SET_GAME_RULES', true)
    commit('SET_ACTIVE_VIEW', 3);
  },

  audioPlayer({ commit }, payload){
    var list = payload.url;
    function autoplay(i, list, finalCycle, currentCycle) {
      currentCycle = currentCycle || 1;
      finalCycle   = finalCycle   || 'infinite repeat'; // [1-n]: numeral value expected.
      let sound = new Howl({
        src: [require('@/assets/audio'+ list[i])], 
        onend: function () {
          if ((i + 1) == list.length) {
            autoplay(0, list, finalCycle, currentCycle)
          } else {
            autoplay(i + 1, list, finalCycle, currentCycle)
          }
        }
      })

      currentCycle===finalCycle+1 && i===0? sound.stop(): sound.play();
      if(i==list.length-1){ currentCycle++ }
    }
    autoplay(0,list,1);
  },
  stopAudio(){
    Howler.stop();
  }
};

const mutations = {
  SET_ACTIVE_GAME(state, payload) {
    if (!payload) return
    state.setup.gameType = payload;
  },
  SET_GAME_MUTE(state, payload) {
    if (!payload) return
    state.setup.mute = payload;
  },
  SET_PLAYER_NAME(state, payload) {
    if (!payload) return
    state.setup.playerName = payload;
  },
  SET_ACTIVE_VIEW(state, payload) {
    if (!payload) return
    state.setup.gameView = payload;
  },
  SET_GAME_LVL(state, payload) {
    if (!payload) return
    state.setup.gameLevel = payload;
  },
  SET_GAME_RULES(state, payload) {
    if (!payload) return
    state.setup.gameRules = payload;
  },
  SET_GAME_DATA(state, payload) {
    if (!payload) return
    state.setup.gameType = payload;
  },
  SET_HANGMAN_LONG(state, payload) {
    if (!payload) return
    state.setup.hangmanLong = payload;
  },
  SET_HANGMAN_DATASET(state, payload) {
    if (payload === 5){
      const helperArr =
        [
          {
            code:'BANK',
            letters:['A','B','D','E','I','J','M','N','S','P','S','Ó','K','Ż','Ą','Ę','Y'],
            img:'bank.png',
            audio:'BANK.mp3'
          },
          {
            code:'BANKIER',
            letters:['A','B','D','E','I','J','M','N','Ą','P','R','W','Z','K',],
            img:'bankier.png',
            audio:'BANKIER.mp3'
          },
          {
            code:'BANKOMAT',
            letters:['A','B','G','E','H','J','M','N','Ą','O','R','W','T','K','M'],
            img:'bankomat.png',
            audio:'BANKOMAT.mp3'
          },
          {
            code:'BUDŻET',
            letters:['A','B','G','E','H','J','U','N','D','O','R','Ż','T','K','M'],
            img:'budzet.png',
            audio:'BUDZET_2.mp3'
          },
          {
            code:'GOTÓWKA',
            letters:['A','B','D','E','G','T','O','N','Ó','P','R','W','Z','K','Ż'],
            img:'gotowka.png',
            audio:'GOTOWKA.mp3'
          },
          // {
          //   code:'KANTOR',
          //   letters:['A','B','D','E','G','T','O','N','Ó','P','R','W','Z','K','Ż'],
          //   img:'kantor.png',
          //   audio:'KANTOR.mp3'
          // },
          {
            code:'KONTO',
            letters:['A','B','D','E','G','T','O','N','Ó','P','R','W','Z','K','Ż'],
            img:'konto_bankowe.png',
            audio:'KONTO.mp3'
          },
          {
            code:'POŻYCZKA',
            letters:['A','C','D','E','G','T','O','K','Ó','P','R','W','Z','Y','Ż'],
            img:'pozyczka.png',
            audio:'POZYCZKA.mp3'
          },
          {
            code:'SALDO',
            letters:['A','S','D','E','G','T','O','K','Ó','P','R','L','Z','Y','Ż'],
            img:'saldo.png',
            audio:'SALDO.mp3'
          }
        ];
      randomArrayShuffle(helperArr, state);

      function randomArrayShuffle(array ,state) {
        let currentIndex = array.length, temporaryValue, randomIndex;
        while (0 !== currentIndex) {
          randomIndex = Math.floor(Math.random() * currentIndex);
          currentIndex -= 1;
          temporaryValue = array[currentIndex];
          array[currentIndex] = array[randomIndex];
          array[randomIndex] = temporaryValue;
        }
        return array;
        console.log(array)
        state.hangman.activeData = array
      }
      state.hangman.activeData = helperArr

    }else{
      const helperArr =
          [
            {
              code:'BANK',
              letters:['A','B','D','E','I','J','M','N','S','P','S','Ó','K','Ż','Ą','Ę','Y'],
              img:'bank.png',
              audio:'BANK.mp3'
            },
            {
              code:'BANKIER',
              letters:['A','B','D','E','I','J','M','N','Ą','P','R','W','Z','K',],
              img:'bankier.png',
              audio:'BANKIER.mp3'
            },
            {
              code:'BANKOMAT',
              letters:['A','B','G','E','H','J','M','N','Ą','O','R','W','T','K','M'],
              img:'bankomat.png',
              audio:'BANKOMAT.mp3'
            },
            {
              code:'BUDŻET',
              letters:['A','B','G','E','H','J','U','N','D','O','R','Ż','T','K','M'],
              img:'budzet.png',
              audio:'BUDZET_2.mp3'
            },
            {
              code:'GOTÓWKA',
              letters:['A','B','D','E','G','T','O','N','Ó','P','R','W','Z','K','Ż'],
              img:'gotowka.png',
              audio:'GOTOWKA.mp3'
            },
            {
              code:'HOLOGRAM',
              letters:['A','B','G','E','H','J','M','N','Ą','O','R','W','L','K','M'],
              img:'hologram.png',
              audio:'HOLOGRAM.mp3'
            },
            {
              code:'INWESTYCJA',
              letters:['A','B','C','E','W','I','M','N','Y','O','R','S','T','J',],
              img:'inwestycja.png',
              audio:'INWESTYCJA.mp3'
            },
            {
              code:'KIESZONKOWE',
              letters:['A','B','K','E','W','I','M','N','Y','O','R','S','Z','J','N'],
              img:'kieszonkowe.png',
              audio:'KIESZONKOWE_2.mp3'
            },
            {
              code:'LIMIT',
              letters:['A','B','C','E','H','I','M','N','Y','O','R','L','T','J','M'],
              img:'limit.png',
              audio:'LIMIT_1.mp3'
            },
            {
              code:'MENNICA',
              letters:['A','B','C','E','H','I','Ó','N','Y','O','R','S','T','J','M'],
              img:'mennica.png',
              audio:'MENNICA.mp3'
            },
            {
              code:'OSZCZĘDNOŚCI',
              letters:['A','Ę','C','E','H','I','D','N','Ś','O','R','S','T','J','Z'],
              img:'oszczednosci.png',
              audio:'OSZCZEDNOSCI.mp3'
            },
            {
              code:'PIENIĄDZ',
              letters:['A','Ą','C','E','H','Z','M','N','I','O','R','D','T','J','M'],
              img:'pieniadz.png',
              audio:'PIENIADZ.mp3'
            },
            {
              code:'PREMIA',
              letters:['A','B','C','E','P','I','M','N','Y','O','R','S','T','J','M'],
              img:'premia.png',
              audio:'PREMIA.mp3'
            },
            {
              code:'TRANSAKCJA',
              letters:['A','B','C','E','H','I','K','N','Y','O','R','S','T','J','M'],
              img:'transakcja.png',
              audio:'TRANSAKCJA_2.mp3'
            },
            {
              code:'WALUTA',
              letters:['A','B','C','W','H','I','M','N','Y','L','R','S','T','U','M'],
              img:'waluta.png',
              audio:'WALUTA.mp3'
            },
            {
              code:'KONTO',
              letters:['A','B','D','E','G','T','O','N','Ó','P','R','W','Z','K','Ż'],
              img:'konto_bankowe.png',
              audio:'KONTO.mp3'
            },
            {
              code:'POŻYCZKA',
              letters:['A','C','D','E','G','T','O','K','Ó','P','R','W','Z','Y','Ż'],
              img:'pozyczka.png',
              audio:'POZYCZKA.mp3'
            },
            {
              code:'SALDO',
              letters:['A','S','D','E','G','T','O','K','Ó','P','R','L','Z','Y','Ż'],
              img:'saldo.png',
              audio:'SALDO.mp3'
            }
          ];

      randomArrayShuffle(helperArr, state);

      function randomArrayShuffle(array ,state) {
        let currentIndex = array.length, temporaryValue, randomIndex;
        while (0 !== currentIndex) {
          randomIndex = Math.floor(Math.random() * currentIndex);
          currentIndex -= 1;
          temporaryValue = array[currentIndex];
          array[currentIndex] = array[randomIndex];
          array[randomIndex] = temporaryValue;
        }
        return array;
        console.log(array)
        state.hangman.activeData = array
      }
      state.hangman.activeData = helperArr
    }
  },
  // SET_HANGMAN_DATA(state, payload){
    // let helperArr = [];
    // if (payload === 5){
    //   let i = 0;
    //
    //   let arr = state.hangman.dataGameEasy
    //   for (i; i < payload ; i++){
    //     helperArr.push(arr[i]);
    //   }
    //   randomArrayShuffle(helperArr, state);
    // }else{
    //   console.log("HARD DATA")
    // }



    // function randomArrayShuffle(array ,state) {
    //   let currentIndex = array.length, temporaryValue, randomIndex;
    //   while (0 !== currentIndex) {
    //     randomIndex = Math.floor(Math.random() * currentIndex);
    //     currentIndex -= 1;
    //     temporaryValue = array[currentIndex];
    //     array[currentIndex] = array[randomIndex];
    //     array[randomIndex] = temporaryValue;
    //   }
    //   return array;
    //   state.hangman.activeData = array
    // }
    // state.hangman.activeData = helperArr


  // },
  SET_SHOP_MAX(state, payload) {
    if (!payload) return
      state.shop.max = payload;
  },
  SET_SHOP_LIMIT(state, payload) {
    if (!payload) return
    state.shop.limit = payload;
  },
  SET_MEMORY_TIME(state, payload) {
    if (!payload) return
    state.setup.memoryTime = payload;
  },
};

const getters = {
  setupGame(state) {
    return state.setup;
  },
  hangmanGame(state){
    return state.hangman;
  },
  hangmanGameActiveData(state){
    return state.hangman.activeData;
  },
  memoryGame(state){
    return state.memory;
  },
  shopGame(state){
    return state.shop;
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
